<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit">
    <v-text-field
      v-model="form.name"
      :rules="rules.required"
      label="Название"
    />

    <v-select
      v-model="form.type"
      label="База данных"
      :items="dbTypes"
    />

    <v-text-field
      v-model="form.host"
      :rules="rules.required"
      label="IP или домен"
    />

    <v-text-field
      v-model="form.port"
      :rules="rules.required"
      label="Порт"
    />

    <v-text-field
      v-model="form.user"
      :rules="rules.required"
      label="Пользователь"
    />

    <v-text-field
      v-model="form.dbpassword"
      :rules="rules.required"
      label="Пароль"
    />

    <v-text-field
      v-model="form.dbname"
      :rules="rules.required"
      label="Название базы данных"
    />

    <div class="d-flex justify-end">
      <v-btn small color="green" dark @click="onSubmit">
        Сохранить
      </v-btn>
    </div>
  </v-form>
</template>

<script>

const createDefaultForm = () => ({
  name: '',
  type: 1,
  host: '',
  port: '5432',
  user: '',
  dbpassword: '',
  dbname: '',
});

const createDefaultRules = () => ({
  required: [
    v => !!v || 'Поле обязательно для заполнения',
  ],
});

export default {
  name: 'external-database-form',
  props: {
    data: {
      type: Object,
      default: createDefaultForm,
    },
  },
  data: () => ({
    valid: true,
    form: createDefaultForm(),
    rules: createDefaultRules(),
    isEdit: false,

    dbTypes: [
      { value: 1, text: 'PostgreSQL' },
      { value: 2, text: 'MySQL' },
    ],
  }),
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(value) {
        this.initData(value);
      },
    },
  },
  methods: {
    initData(data) {
      this.isEdit = data.id !== undefined;
      this.form = {
        ...this.form,
        ...JSON.parse(JSON.stringify(data)),
      };
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit('submit', {
          form: {
            ...this.form,
            dbuser: this.form.user,
            dbtype: this.form.type,
          },
          isEdit: this.isEdit,
        });
        this.form = createDefaultForm();
        this.isEdit = false;
      }
    },
  },
};
</script>

<style scoped>

</style>
